module.exports = __webpack_public_path__ + "media/application/images/icons/n-a-60763866096a66b6c28595ba29f437ae.png";